import { Stack } from "@fluentui/react"
import { IIdentificationConfig, ProcessStages } from "@piceasoft/core"
import { Dispatch } from "react"
import { ParameterItem } from "../../../components/ParameterItem"
import { strings } from "../../../../../../localization/strings"
import { actionCreators } from "../../../../../../core/actions/configurator-actions"

type TProps = {
    config: IIdentificationConfig
    onChangeDispatch: Dispatch<any>
    channel: number
}

export const IdentificationUIFlowPivot: React.FC<TProps> = ({ config, ...props }) => {
    return (
        <Stack.Item>
            <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.UI_FLOW.SELECT_TARGET.TITLE}
                key="ui_flow_1"
                useToggle
                noSeparator
                toggleEnabled={true}
                toggleChecked={config?.targetDeviceSelection ? true : false}
                toggleOnChange={() => {
                    props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                        ...config,
                        targetDeviceSelection: config?.targetDeviceSelection ? undefined : {}
                    } as IIdentificationConfig
                    ))
                }}
                description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.UI_FLOW.SELECT_TARGET.DESCRIPTION}
            />
            {config?.targetDeviceSelection && (
                <ParameterItem title={strings.CONSTRUCTOR.IDENTIFICATION.COMMON.PIVOTS.UI.TITLE_TITLE}
                    key="ui_flow_2"
                    useToggle
                    toggleEnabled
                    toggleChecked={config?.targetDeviceSelection?.title !== undefined ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            targetDeviceSelection: {
                                ...config?.targetDeviceSelection,
                                title: config?.targetDeviceSelection?.title !== undefined ? undefined : ""
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                    description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.TITLE_DESCRIPTION}
                    useTextField
                    textFieldValue={config?.targetDeviceSelection?.title}
                    textFieldEnabled={config?.targetDeviceSelection?.title !== undefined ? true : false}
                    textFieldOnChange={(val) => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            targetDeviceSelection: {
                                ...config?.targetDeviceSelection,
                                title: val
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                />
            )}
            {config?.targetDeviceSelection && (
                <ParameterItem title={strings.CONSTRUCTOR.IDENTIFICATION.COMMON.PIVOTS.UI.INFORMATION_TITLE}
                    key="ui_flow_3"
                    useToggle
                    toggleEnabled
                    toggleChecked={config?.targetDeviceSelection.information !== undefined ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            targetDeviceSelection: {
                                ...config?.targetDeviceSelection,
                                information: config?.targetDeviceSelection?.information !== undefined ? undefined : ""
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                    description={strings.CONSTRUCTOR.INSPECTIONS.COMMON.PIVOTS.UI.DESCRIPTION_DESCRIPTION}
                    useTextField
                    textFieldEnabled={config?.targetDeviceSelection?.information !== undefined ? true : false}
                    textFieldValue={config?.targetDeviceSelection?.information}
                    textFieldOnChange={(val) => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            targetDeviceSelection: {
                                ...config?.targetDeviceSelection,
                                information: val
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                />
            )}

        </Stack.Item>
    );
}